import React, { lazy, Suspense, useEffect, useState } from "react";
import ReactDOM from "react-dom/client";
import App from "./App.jsx";
import "./index.css";
import { BrowserRouter, useLocation } from "react-router-dom";
import { Provider } from "react-redux";
import { store } from "./redux/index.js";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
// import { ToastContainer, toast } from "react-toast";
import { GoogleOAuthProvider } from "@react-oauth/google";
const ToastHost = lazy(() => import("./components/common/ToastHost"));

const GOOGLE_WEB_CLIENT_ID =
  import.meta.env.VITE_GOOGLE_WEB_CLIENT_ID ||
  "962360493134-6ajeigedfskkdee3gjtfbmp89t03dt7c.apps.googleusercontent.com";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // staleTime: Infinity,
      refetchOnWindowFocus: false,
      retry: 0,
    },
  },
});

const GOOGLE_AUTH_ROUTE_RE = /^\/(sign-in|login|admin\/login|admin\/sign-in)(\/|$)/;

function ShellContent() {
  const [showToastHost, setShowToastHost] = useState(false);

  useEffect(() => {
    setShowToastHost(true);
  }, []);

  return (
    <>
      <App />
      {showToastHost ? (
        <Suspense fallback={null}>
          <ToastHost />
        </Suspense>
      ) : null}
    </>
  );
}

function AppShell() {
  const location = useLocation();
  const needsGoogleOAuthProvider = GOOGLE_AUTH_ROUTE_RE.test(location.pathname);

  if (!needsGoogleOAuthProvider) {
    return <ShellContent />;
  }

  return (
    <GoogleOAuthProvider clientId={GOOGLE_WEB_CLIENT_ID}>
      <ShellContent />
    </GoogleOAuthProvider>
  );
}

ReactDOM.createRoot(document.getElementById("root")).render(
  <Provider store={store}>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <AppShell />
      </BrowserRouter>
    </QueryClientProvider>
  </Provider>
);
